import { observer } from 'mobx-react-lite'
import { Preview } from 'components/Preview/Preview'
import { useCreateTriggerContext } from 'src/pages/main/triggers/create/state/CreateTriggerState'

export const PreviewTrigger = observer(() => {
  const createTriggerStore = useCreateTriggerContext()
  return <Preview message={createTriggerStore.previewMessage} />
})
